import { guidanceCardAiLibrariesInternal } from "../../../../src/components/guidance-cards/guidance-card-content";
import { GuidanceCard } from "../../../../src/components/guidance-cards/guidance-cards";
import { Stack } from '@atlaskit/primitives';
import Image from '@atlaskit/image';
import SectionMessage from '@atlaskit/section-message';
import AiCreateLight from "../../../../src/pages/patterns/rovo-ai/_assets/ai-create-light.png";
import AiCreateDark from "../../../../src/pages/patterns/rovo-ai/_assets/ai-create-dark.png";
import AiGenFooterLight from "../../../../src/pages/patterns/rovo-ai/_assets/ai-gen-footer-light.png";
import AiGenFooterDark from "../../../../src/pages/patterns/rovo-ai/_assets/ai-gen-footer-dark.png";
import ChatLight from "../../../../src/pages/patterns/rovo-ai/_assets/chat-light.png";
import ChatDark from "../../../../src/pages/patterns/rovo-ai/_assets/chat-dark.png";
import FloatingLight from "../../../../src/pages/patterns/rovo-ai/_assets/floating-light.png";
import InlinePromptLight from "../../../../src/pages/patterns/rovo-ai/_assets/inline-prompt-light.png";
import InlinePromptDark from "../../../../src/pages/patterns/rovo-ai/_assets/inline-prompt-dark.png";
import MessageCardLight from "../../../../src/pages/patterns/rovo-ai/_assets/message-card-light.png";
import MessageCardDark from "../../../../src/pages/patterns/rovo-ai/_assets/message-card-dark.png";
import FloatingDark from "../../../../src/pages/patterns/rovo-ai/_assets/floating-dark.png";
import LogoAndIconsLight from "../../../../src/pages/patterns/rovo-ai/_assets/logo-and-icons-light.png";
import LogoAndIconsDark from "../../../../src/pages/patterns/rovo-ai/_assets/logo-and-icons-dark.png";
import RovoButtonLight from "../../../../src/pages/patterns/rovo-ai/_assets/rovo-button-light.png";
import RovoButtonDark from "../../../../src/pages/patterns/rovo-ai/_assets/rovo-button-dark.png";
import RovoCuesLight from "../../../../src/pages/patterns/rovo-ai/_assets/rovo-cues-light.png";
import RovoCuesDark from "../../../../src/pages/patterns/rovo-ai/_assets/rovo-cues-dark.png";
import SidebarLight from "../../../../src/pages/patterns/rovo-ai/_assets/sidebar-light.png";
import SidebarDark from "../../../../src/pages/patterns/rovo-ai/_assets/sidebar-dark.png";
import SkillLight from "../../../../src/pages/patterns/rovo-ai/_assets/skill-light.png";
import SkillDark from "../../../../src/pages/patterns/rovo-ai/_assets/skill-dark.png";
import TelePointersLight from "../../../../src/pages/patterns/rovo-ai/_assets/telepointers-light.png";
import TelePointersDark from "../../../../src/pages/patterns/rovo-ai/_assets/telepointers-dark.png";
import * as React from 'react';
export default {
  guidanceCardAiLibrariesInternal,
  GuidanceCard,
  Stack,
  Image,
  SectionMessage,
  AiCreateLight,
  AiCreateDark,
  AiGenFooterLight,
  AiGenFooterDark,
  ChatLight,
  ChatDark,
  FloatingLight,
  InlinePromptLight,
  InlinePromptDark,
  MessageCardLight,
  MessageCardDark,
  FloatingDark,
  LogoAndIconsLight,
  LogoAndIconsDark,
  RovoButtonLight,
  RovoButtonDark,
  RovoCuesLight,
  RovoCuesDark,
  SidebarLight,
  SidebarDark,
  SkillLight,
  SkillDark,
  TelePointersLight,
  TelePointersDark,
  React
};